const TZ_CUIABA = 'America/Cuiaba';
const TZ_BRASILIA = 'America/Sao_Paulo';

export const ensureDate = (value) => {
  if (!value) return new Date();
  if (value instanceof Date) return new Date(value.getTime());
  return new Date(value);
};

export const startOfDayCuiaba = (value) => {
  const dt = ensureDate(value);
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ_CUIABA, year: 'numeric', month: '2-digit', day: '2-digit'
  });
  const [year, month, day] = formatter.format(dt).split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
};

export const endOfDayCuiaba = (value) => {
  const dt = ensureDate(value);
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ_CUIABA, year: 'numeric', month: '2-digit', day: '2-digit'
  });
  const [year, month, day] = formatter.format(dt).split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999));
};

export const startOfWeekCuiaba = (date) => {
  const monday = startOfDayCuiaba(date);
  const dayOfWeek = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ_CUIABA, weekday: 'short'
  }).format(ensureDate(date));
  const map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  const diff = map[dayOfWeek] - 1;
  const daysToSubtract = diff >= 0 ? diff : 6;
  monday.setUTCDate(monday.getUTCDate() - daysToSubtract);
  return monday;
};

// Fim da semana: domingo 23:59:59.999 na mesma escala de startOfWeekCuiaba/toCuiabaTimestamp
export const endOfWeekCuiaba = (date) => {
  const sunday = startOfWeekCuiaba(date);
  sunday.setUTCDate(sunday.getUTCDate() + 6);
  sunday.setUTCHours(23, 59, 59, 999);
  return sunday;
};

// Janela do ranking: segunda 00:00 até domingo 22:00, horário de Brasília (UTC-3 fixo).
// Devolve instantes reais: comparar com new Date(c.data), não com toCuiabaTimestamp.
const HORA_MS = 3600000;
const FMT_DIA_BRASILIA = new Intl.DateTimeFormat('en-CA', {
  timeZone: TZ_BRASILIA, year: 'numeric', month: '2-digit', day: '2-digit'
});
export const janelaRankingBrasilia = (value) => {
  const [year, month, day] = FMT_DIA_BRASILIA.format(ensureDate(value)).split('-').map(Number);
  const diasDesdeSegunda = (new Date(Date.UTC(year, month - 1, day)).getUTCDay() + 6) % 7;
  const segunda = Date.UTC(year, month - 1, day - diasDesdeSegunda);
  return {
    inicio: new Date(segunda + 3 * HORA_MS),
    fim: new Date(segunda + (6 * 24 + 22 + 3) * HORA_MS)
  };
};

// Ranking do mês: dia 1 às 00:00 até o início do mês seguinte (fim exclusivo), horário de Brasília
export const janelaRankingMesBrasilia = (value) => {
  const [year, month] = FMT_DIA_BRASILIA.format(ensureDate(value)).split('-').map(Number);
  return {
    inicio: new Date(Date.UTC(year, month - 1, 1) + 3 * HORA_MS),
    fim: new Date(Date.UTC(year, month, 1) + 3 * HORA_MS)
  };
};

const FMT_DIA_MES_BRASILIA = new Intl.DateTimeFormat('pt-BR', {
  timeZone: TZ_BRASILIA, day: '2-digit', month: '2-digit'
});
export const formatDiaMesBrasilia = (value) => FMT_DIA_MES_BRASILIA.format(ensureDate(value));

// Formatadores reaproveitados: criar um por comanda pesa quando a lista tem milhares de itens
const FMT_TIMESTAMP = new Intl.DateTimeFormat('en-CA', {
  timeZone: TZ_CUIABA, year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
});
const FMT_HORA = new Intl.DateTimeFormat('pt-BR', {
  timeZone: TZ_CUIABA, hour: '2-digit', minute: '2-digit'
});
const FMT_DATA = new Intl.DateTimeFormat('pt-BR', {
  timeZone: TZ_CUIABA, day: '2-digit', month: '2-digit', year: 'numeric'
});
const FMT_DATA_KEY = new Intl.DateTimeFormat('en-CA', {
  timeZone: TZ_CUIABA, day: '2-digit', month: '2-digit', year: 'numeric'
});
const FMT_DATA_PERIODO = new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric'
});

export const toCuiabaTimestamp = (value) => {
  const date = ensureDate(value);
  const formatted = FMT_TIMESTAMP.format(date);
  const [ymd, time] = formatted.split(', ');
  const [year, month, day] = ymd.split('-').map(Number);
  const [hour, minute, second] = time.split(':').map(Number);
  return Date.UTC(year, month - 1, day, hour, minute, second);
};

export const formatHoraCuiaba = (value) => FMT_HORA.format(ensureDate(value));

export const formatDataCuiaba = (value) => FMT_DATA.format(ensureDate(value));

export const formatDataKeyCuiaba = (value) => FMT_DATA_KEY.format(ensureDate(value));

// Para limites de período (startOfWeekCuiaba etc.), que já estão deslocados para a escala de Cuiabá
export const formatDataPeriodo = (value) => FMT_DATA_PERIODO.format(ensureDate(value));

export const normalizarComanda = (comanda = {}, fallback = {}) => {
  const baseData = comanda.dataLancamentoISO || comanda.data || comanda.createdAt || Date.now();
  const dataReferencia = ensureDate(baseData);
  const servicosNormalizados = Array.isArray(comanda.servicos)
    ? comanda.servicos.map((servico) => ({
        ...servico,
        preco: parseFloat(servico.preco) || 0,
        comissao: servico.comissao !== undefined && servico.comissao !== null
          ? parseFloat(servico.comissao) : servico.comissao ?? null
      }))
    : [];
  const barbeiroNome = comanda.barbeiroNome || comanda.barbeiro?.nome || fallback.barbeiroNome || '';
  return {
    ...comanda, ...fallback,
    total: parseFloat(comanda.total) || 0,
    servicos: servicosNormalizados,
    horaLancamento: comanda.horaLancamento || formatHoraCuiaba(dataReferencia),
    dataLancamento: comanda.dataLancamento || formatDataCuiaba(dataReferencia),
    dataLancamentoISO: comanda.dataLancamentoISO || dataReferencia.toISOString(),
    dataLancamentoKey: comanda.dataLancamentoKey || formatDataKeyCuiaba(dataReferencia),
    barbeiroNome,
    data: comanda.data || dataReferencia.toISOString()
  };
};

// Atualiza pelo id sem descartar o que já está carregado; mais recentes primeiro
export const mesclarComandas = (atuais, novas) => {
  const porId = new Map(atuais.map((c) => [c.id, c]));
  novas.forEach((c) => porId.set(c.id, c));
  return [...porId.values()].sort((a, b) => ensureDate(b.data) - ensureDate(a.data));
};

// Percentual gravado no serviço; 0 é um valor válido, só a ausência usa o padrão
export const percentualComissao = (servico, padrao = 48) => {
  const valor = parseFloat(servico?.comissao);
  return Number.isFinite(valor) ? valor : padrao;
};

export const fmtBRL = (n) => 'R$ ' + (Number(n) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtN = (n) => (Number(n) || 0).toLocaleString('pt-BR');
